/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

(function () {
  /**
   * Filter module for pluralization.
   */
  angular.module('filters.capitalizeFirstLetter', []).filter('capitalizeFirstLetter', function () {
    return capitalizeFirstLetter;
  });

  /**
   * Filter used for capitalizing the first letter in a string. CSS has text-transform: capitalize, but that capitalizes
   * the first letter of every word. CSS also has the ::first-letter pseudo-element, but that only works for block or
   * inline-block elements that don't have any content to their left:
   *
   * https://stackoverflow.com/questions/7631722/css-first-letter-not-working
   *
   * @param {String} input - The input string.
   * @returns The input string with its first letter capitalized.
   */
  function capitalizeFirstLetter(input) {
    var output = input;
    if (input && input.length > 0) {
      output = input.charAt(0).toUpperCase() + input.slice(1);
    }
    return output;
  }
})();
